import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DontTreeShake } from '@epicuro-next/elements/core';
import { ListCallToActionModule } from '@epicuro-next/features/engagement/list-call-to-action';
import { DynamicElementsShopTheCommercialListComponent } from './component/dynamic-elements-shop-the-commercial-list/dynamic-elements-shop-the-commercial-list.component';

@NgModule({
  imports: [CommonModule, ListCallToActionModule],
  declarations: [DynamicElementsShopTheCommercialListComponent],
})
export class DynamicElementsShopTheCommercialListModule {}

DontTreeShake(DynamicElementsShopTheCommercialListComponent);
